import isElementInViewport from './viewport';

const initCircleAnimation = () => {
  // General variables
  const circleAnimation: NodeListOf<HTMLElement> = document.querySelectorAll('.circle_animation');

  // Functions
  const activeCircleAnimation = () => {
    [...circleAnimation].forEach((circle) => {
      if (isElementInViewport(circle)) {
        circle.classList.add('circle_animation--active');
      }
    });
  };

  // Loop through all the line animations
  activeCircleAnimation();

  // On scroll check viewport
  window.addEventListener('scroll', () => {
    activeCircleAnimation();
  });
};

export default initCircleAnimation;
